<template>
  <div id="SectionAchievedTarget">
    <UIContainer class="SectionAchievedTarget__container">
      <template #left>
        <img
          class="SectionAchievedTarget__image"
          src="../assets/achievedTarget/bg.avif"
          alt="Governance & Controls (Factors, Scope 2, Evidence Vault)"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionAchievedTarget__content">
          <SectionAchievedTargetReviewCarousel />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import SectionAchievedTargetReviewCarousel from '../components/SectionAchievedTargetReviewCarousel.vue'
</script>

<style lang="scss" scoped>
#SectionAchievedTarget {
  position: relative;
  padding: 4rem 0;
  background-color: $color-ui-gray-cool-50;

  .SectionAchievedTarget__container {
    background-color: $color-ui-gray-cool-50;
    padding-top: 0;
    padding-bottom: 0;

    @include md {
      :deep(.UIContainer__grid) {
        display: flex;
        .UIContainer__left {
          width: 40%;
          padding: 2rem 1rem;
        }
        .UIContainer__right {
          width: 60%;
        }
      }
    }
  }

  .SectionAchievedTarget__image {
    display: none;
    width: 100%;
    max-height: 32rem;
    border-radius: 1.5rem;

    @include md {
      display: block;
    }
  }

  .SectionAchievedTarget__content {
    // @include md {
    //   margin-left: 2rem;
    //   height: 348px;
    // }

    .ReviewCarouselTabs {
      max-width: 100%;
    }
  }

  // Removed unused blocks: title, features, feature, feature-icon, cta
}
</style>
